import { makeStyles } from '@material-ui/core'

export const logsStyles = makeStyles((theme: any) => {
  return {
    headerWrapper: {
      padding: theme.spacing(1),
      paddingRight: 0,
      height: theme.logs.titleHeight,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    exportHeaderButton: {
      whiteSpace: 'nowrap',
    },
    contentIndent: {
      paddingLeft: theme.spacing(1),
    },
    exportButton: {
      position: 'absolute',
      left: '50%',
      right: '50%',
      bottom: '10px',
      width: 'fit-content',
    },
    exportButtonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.logs.buttonWrapperHeight,
    },
  }
})

